import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/login'));
const JwtVerifyPage = lazy(() => import('src/pages/auth/verify'));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        element: (
          <AuthClassicLayout>
            <JwtLoginPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'verify',
        element: (
          <AuthClassicLayout>
            <JwtVerifyPage />
          </AuthClassicLayout>
        ),
      },
    ],
  },
];
